import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { countNotCleared } from "@/lib/bills-util";

// Lightweight context that owns the "Not-Cleared / Pending" bill count shown
// as a red pill on the Bills sidebar link. Pages that mutate bills should call
// refresh() so the badge updates without a full app reload.
const BillsBadgeContext = createContext({ count: 0, refresh: () => {} });

export function BillsBadgeProvider({ children }) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/bills");
      setCount(countNotCleared(data));
    } catch { /* non-fatal */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <BillsBadgeContext.Provider value={{ count, refresh }}>
      {children}
    </BillsBadgeContext.Provider>
  );
}

export function useBillsBadge() {
  return useContext(BillsBadgeContext);
}
